import React from "react";
import LanguageMarquee from "./LanguageMarquee";

const Skills = () => {
  return (
    <div id="skills" className="bg-theme-default">
      <div className="container mx-auto px-4 text-center py-4">
        <h2 className="text-3xl md:text-5xl font-bold mb-4">Skills</h2>

        <LanguageMarquee></LanguageMarquee>
      </div>
    </div>
  );
};

export default Skills;
